// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! * [Scalable Text in CSS with Maximum and Minimum Sizes](https://github.com/kevinmack18/SCALABLE-TEXT-IN-CSS) */client-only[data-v-088514a2]{width:100%}.space-fix[data-v-088514a2]{width:16.6666666667%}@media only screen and (max-width:375px){.space-fix[data-v-088514a2]{width:50%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
